export const Rights = [
    "WEB_MODULE_PILOT_TRANSPORT_CONTACT_ADMIN_WRITE"
]
